import LoadingBox from 'components/Common/Loading/LoadingBox'
import Group from 'components/utils/Group'
import React from 'react'

function CarHireUpsellOfferTileLoadingSkeleton() {
  return <Group direction="vertical" gap={16}>
    <LoadingBox style={{ width: 300, height: 155 }}/>
    <Group direction="vertical" gap={12} verticalAlign="space-between">
      <Group direction="vertical" gap={4}>
        <LoadingBox style={{ width: 100, height: 16 }}/>
        <LoadingBox style={{ width: 200, height: 28 }}/>
      </Group>
      <Group direction="vertical" gap={0}>
        <LoadingBox style={{ width: 80, height: 24 }}/>
        <LoadingBox style={{ width: 75, height: 20 }}/>
      </Group>
    </Group>
  </Group>
}

export default CarHireUpsellOfferTileLoadingSkeleton
